import React from 'react'
import { IItemInterface } from '../data/dataInterface';
import { Product } from './Product';
import { ProductMinimo } from './ProductMinimo';
import { ScrollTop } from 'primereact/scrolltop';

interface Props {
    items: IItemInterface[];
}
export const ProductListMinimo = ({items} : Props) => {
  return (
    <div className="flex flex-row justify-content-start flex-wrap">
        {items.map((item: IItemInterface) => {
            if (item.limit) {
              return <ProductMinimo 
                        indicator={item.indicator}
                        name={item.name}
                        description={item.description}
                        image={item.image}
                        alergenos={item.alergenos} 
                        picante={item.picante}
                        limit={item.limit}
                        key={item.indicator+item.name}/>
            } else {
              return <ProductMinimo 
                        indicator={item.indicator}
                        name={item.name}
                        description={item.description}
                        image={item.image}
                        alergenos={item.alergenos} 
                        picante={item.picante}
                        key={item.indicator+item.name}/>
            }
        })}
    </div>
  )
}
